import { render, staticRenderFns } from "./CheckinDDATForm.vue?vue&type=template&id=24799038&"
import script from "./CheckinDDATForm.vue?vue&type=script&lang=js&"
export * from "./CheckinDDATForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports